var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["mku-tips-wrapper", { "mku-tips-notice": _vm.isNotice }] },
    [
      _c(
        "transition-group",
        {
          staticClass: "mku-tips__content",
          attrs: { tag: "ul", name: "mku-tips-transition" }
        },
        _vm._l(_vm.tips, function(item) {
          return _c(
            "li",
            { key: item._ulid, class: _vm.tipItemClassName(item) },
            [
              _c("div", { staticClass: "mku-tips__item-wrap" }, [
                _c(
                  "div",
                  { staticClass: "mku-tips__item-content" },
                  [
                    item.icon
                      ? _c("mku-icon", {
                          attrs: {
                            "class-name": "mku-tips__icon-type",
                            type: item.icon
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "mku-tips__info" }, [
                      _c(
                        "div",
                        {
                          class: [
                            "mku-tips__title",
                            { "mku--isBold": item.content || item.render }
                          ]
                        },
                        [
                          item.render && _vm.type === "message"
                            ? [
                                _c("p", {
                                  domProps: { innerHTML: _vm._s(item.render) }
                                })
                              ]
                            : [_vm._v(_vm._s(item.title))]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.type === "notice" && (item.content || item.render)
                        ? _c(
                            "div",
                            { staticClass: "mku-tips__desc" },
                            [
                              item.render
                                ? [
                                    _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(item.render)
                                      }
                                    })
                                  ]
                                : [_vm._v(_vm._s(item.content))]
                            ],
                            2
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    item.closeable
                      ? _c("mku-icon", {
                          attrs: {
                            type: "close",
                            "class-name": "mku-tips__icon-close"
                          },
                          on: {
                            click: function($event) {
                              return _vm.remove(item)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }